import React from 'react';
import { Body, Heading } from '../../atoms';
export default function SimpleDatalist(param) {
    var entries = param.entries, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6 grid-flow-row auto-rows-max grid-cols-1 sm:gap-8"
    }, entries.map(function(entry) {
        return /*#__PURE__*/ React.createElement("div", {
            key: entry.label,
            className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-5 border-b pb-6 border-b-fg-base/30 last-of-type:border-b-0 sm:gap-8 sm:grid-cols-2 sm:pb-8"
        }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
            as: "h4",
            variant: "h4"
        }, entry.label)), /*#__PURE__*/ React.createElement("div", null, entry.values.map(function(value) {
            return /*#__PURE__*/ React.createElement("div", {
                key: value
            }, /*#__PURE__*/ React.createElement(Body, {
                variant: "md"
            }, value));
        })));
    })));
}

//# sourceMappingURL=SimpleDatalist.js.map